import { render } from "./edit_module.vue?vue&type=template&id=bf4f7556&scoped=true"
import script from "./edit_module.vue?vue&type=script&lang=js"
export * from "./edit_module.vue?vue&type=script&lang=js"

import "./edit_module.vue?vue&type=style&index=0&id=bf4f7556&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf4f7556"]])

export default __exports__